/* 1sttoy — scroll-scrubbed hero film. Passive scroll + rAF; frames drawn to canvas with cover fit.
   Frame 1 is the plain <img> already painted, so nothing depends on this script to render.
   Audit fix 28 Sep 2026 — progressive loading: nothing is fetched until the page has loaded and the browser is idle; then only a
   few frames ahead of the current scroll position, two at a time, and only while the hero is on screen. Skipped entirely on
   Save-Data, 2g/3g connections and reduced motion (the still image stays). Every second frame is used (half the downloads).
   Phones and short pins: when the hero is not pinned, the film plays as the hero scrolls out of view. */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn && (conn.saveData || /(^|-)(2g|3g)$/.test(conn.effectiveType || ''))) return;
  var root = document.querySelector('[data-ryh-scrub]'); if (!root) return;
  var canvas = root.querySelector('.ryh-scrub__canvas'); if (!canvas || !canvas.getContext) return;
  var ctx = canvas.getContext('2d', { alpha: false });
  var rail = root.querySelector('.ryh-scrub__rail-fill');
  var mobile = window.matchMedia('(max-width: 767px)').matches;
  var available = parseInt(root.getAttribute(mobile ? 'data-m-frames' : 'data-d-frames'), 10) || 48;
  var STRIDE = 2, AHEAD = 4, PARALLEL = 2;
  var total = Math.ceil(available / STRIDE);
  var base = root.getAttribute(mobile ? 'data-m-base' : 'data-d-base');
  var suffix = root.getAttribute(mobile ? 'data-m-suffix' : 'data-d-suffix');
  var prefix = mobile ? 'ryh-scrub-m-' : 'ryh-scrub-d-';
  function url(i) { var n = String(Math.min(available, i * STRIDE + 1)); while (n.length < 3) n = '0' + n; return base + prefix + n + suffix; }

  var sized = false, frames = new Array(total), inflight = 0, current = -1, live = false, visible = false, ready = false, idleQueued = false;
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  function ok(img) { return img && img.complete && img.naturalWidth; }
  function size() { sized = true; canvas.width = Math.round(canvas.clientWidth * dpr); canvas.height = Math.round(canvas.clientHeight * dpr); current = -1; draw(); }
  function progress() {
    var r = root.getBoundingClientRect(), span = root.offsetHeight - window.innerHeight;
    if (span > 40) return Math.min(1, Math.max(0, -r.top / span));          /* pinned: scrub across the pin */
    return Math.min(1, Math.max(0, -r.top / Math.max(1, r.height * 0.9)));    /* not pinned: scrub while it scrolls away */
  }
  function target() { var p = progress(); if (rail) rail.style.transform = 'scaleX(' + p + ')'; return Math.min(total - 1, Math.round(p * (total - 1))); }
  function draw() {
    var i = target(); if (i === current) return;
    var img = frames[i];
    if (!ok(img)) { var j = i; while (j >= 0 && !ok(frames[j])) j--; if (j < 0) return; img = frames[j]; }
    var cw = canvas.width, ch = canvas.height; if (!cw || !ch) return;
    var iw = img.naturalWidth, ih = img.naturalHeight, s = Math.max(cw / iw, ch / ih), w = iw * s, h = ih * s;
    ctx.drawImage(img, (cw - w) / 2, (ch - h) / 2, w, h); current = i;
    if (!live) { live = true; root.classList.add('is-live'); }
  }
  function nextWanted() {
    var t = Math.max(0, target());
    for (var i = t; i <= Math.min(total - 1, t + AHEAD); i++) if (!frames[i]) return i;
    for (var k = t - 1; k >= Math.max(0, t - 2); k--) if (!frames[k]) return k;
    return -1;
  }
  function load(i) {
    var im = new Image(); im.decoding = 'async'; frames[i] = im; inflight++;
    im.onload = im.onerror = function () { inflight--; if (ok(im) && !sized) size(); else draw(); schedule(); };
    im.src = url(i);
  }
  function pump() {
    idleQueued = false;
    if (!ready || !visible) return;
    while (inflight < PARALLEL) { var i = nextWanted(); if (i < 0) return; load(i); }
  }
  function schedule() {
    if (idleQueued || !ready || !visible) return; idleQueued = true;
    if (window.requestIdleCallback) window.requestIdleCallback(pump, { timeout: 800 }); else setTimeout(pump, 200);
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { visible = es[0].isIntersecting; schedule(); }, { rootMargin: '100px 0px' }).observe(root);
  } else visible = true;
  function start() { ready = true; schedule(); }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking || !visible) return; ticking = true;
    requestAnimationFrame(function () { ticking = false; draw(); schedule(); });
  }, { passive: true });
  window.addEventListener('resize', function () { dpr = Math.min(window.devicePixelRatio || 1, 2); if (sized) size(); }, { passive: true });
})();
